import { createStyles } from "@mantine/core"
import type { MantineTheme } from "@mantine/core"

export const useStyles = createStyles((theme: MantineTheme) => ({
    anchor: {
        marginBottom: theme.spacing.sm,
        marginTop: theme.spacing.sm,
        paddingLeft: theme.spacing.sm,
        paddingRight: theme.spacing.sm,

        "&:active,&:focus,&:hover,&:link,&:visited": {
            backgroundColor: "transparent",
            color: theme.white,
            outlineColor: theme.white,
        },
    },
    flex: {
        backgroundColor: theme.colors.red[5],

        "&:not(:focus-within)": {
            clip: "rect(0, 0, 0, 0)",
            maxHeight: 0,
            overflow: "hidden",
            transition: "max-height 1.5s",
            whiteSpace: "nowrap",
        },

        "&:focus-within": {
            clip: "auto",
            maxHeight: "500px",
            overflow: "auto",
            transition: "max-height 0.5s ease-in",
            whiteSpace: "normal",
        },
    },
}))
